import * as t from "io-ts";
import * as JsonResponse1 from "./JsonResponse1";
import * as ListingStatusCount1 from "./ListingStatusCount1";

export const codec = JsonResponse1.createCodec(
    t.array(ListingStatusCount1.codec),
    t.type({}),
);

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    data: [],
    meta: {},
});
